import React from 'react';
import PanettoneQuotaSupervisors from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/QuotaSupervisors/List.js';

export default function () {
  return <PanettoneQuotaSupervisors />;
}
